import React from 'react';
import block from 'bem-cn-lite';
import store from '../state';
import { I18n } from 'react-i18next';
import i18n from '../../i18n';

const user = {
    name: i18n.t('customWorkflow:userName')
}

class Comment extends React.Component {
    render() {
        const b = block('TaskComment');
        const { name, color } = this.props.getCurrentStatus()

        const colorStyle = {
            color: `rgb(${color})`
        }

        return (
            <I18n ns={ ['customWorkflow'] }>
                {
                    (t, { i18n }) => (
                        <div className={b()}>
                            <div className={b('avatar')}>
                                <div className={b('default-avatar')}>{user.name[0]}</div>
                            </div>
                            <div className={b('body')}>
                                <div className={b('info')}>
                                    <span className={b('name')}>{user.name}</span>
                                </div>
                                <div className={b('message')}></div>
                                <div className={b('actions')}>
                                    <div className={b('action')}>{t('customWorkflow:statusChangedTo')} <span style={colorStyle} className={b('action', { 'status-name': true })}>{name}</span></div>
                                </div>
                            </div>
                        </div>
                    )
                }
            </I18n>

        )
    }
}

export default store(Comment)